import { appConfig } from '~/common/config';

const url = `${appConfig.superset.url}/login/SSO?next=`;

export const Superset = () => {
  return <iframe src={url} title="Superset" style={{ minHeight: '99%', width: '100%', border: 0 }} />;
};
